import React, { useState, useContext } from 'react';
import { Segment, Form, Button } from 'semantic-ui-react';

import { RequestReviewNoteFormValues } from '../../../../App/models/RequestReviewNote'
import { observer } from 'mobx-react-lite';
import { Form as FinalForm, Field } from 'react-final-form';

import TextAreaInput from '../../../../App/common/form/TextAreaInput';
import SelectInput from '../../../../App/common/form/SelectInput';

import {
  combineValidators,
  isRequired,
  composeValidators,
  hasLengthLessThan
} from 'revalidate';

import { RootStoreContext } from '../../../../App/stores/RootStore'

const validate = combineValidators({
  requestReviewId: isRequired('requestReviewId'),
  noteType: isRequired('noteType'),
  note: composeValidators(
    isRequired('note'),
    hasLengthLessThan(300)({ message: 'Notes have a 300 char limit' })
  )(),
});

interface NoteParams {
  requestReviewId: string;
  requestReviewNoteId: string;
  noteType: string;
  note: string;
}


const RequestReviewNoteForm: React.FC<NoteParams> = (match) => {
  const rootStore = useContext(RootStoreContext);

  const { createRequestReviewNote, submitting } = rootStore.requestReviewNoteStore;
  const { loadRequestReviewNotes } = rootStore.requestReviewNoteStore;
  const { closeModal } = rootStore.modalStore;
  const { getNoteOptions } = rootStore.commonStore;

  const [requestNote] = useState(new RequestReviewNoteFormValues(match.requestReviewId));
  requestNote.note = match.note;
  requestNote.id = match.requestReviewNoteId;
  requestNote.noteType = match.noteType;

  const [loading] = useState(false);

  const handleFinalFormSubmit = (values: any) => {
    const { ...requestReviewNote } = values;
    createRequestReviewNote(requestReviewNote)
      .then(r => loadRequestReviewNotes(match.requestReviewId));
  };

  return (
    <Segment clearing>
      <FinalForm
        validate={validate}
        initialValues={requestNote}
        onSubmit={handleFinalFormSubmit}
        render={({ handleSubmit, invalid, pristine }) => (
          <Form onSubmit={handleSubmit} loading={loading}>

            <Field
              component={SelectInput}
              options={getNoteOptions(["Recommendation", "Escalation", "Review"])}
              name='noteType'
              placeholder='NoteType'
              value={requestNote.noteType}
            />

            <Field
              rows={4}
              name='note'
              placeholder='Note'
              value={requestNote.note}
              component={TextAreaInput}
            />

            <Button
              loading={submitting}
              disabled={loading || invalid || pristine || submitting}
              floated='right'
              positive
              type='submit'
              content='Submit'
            />

            <Button
              onClick={() => closeModal()}
              disabled={loading}
              floated='left'
              type='button'
              content='Cancel'
            />
          </Form>
        )}
      />
    </Segment>
  );
};

export default observer(RequestReviewNoteForm);
